import React from 'react';
import { styled, View } from 'tamagui';

const SkeletonContainer = styled(View, {
  backgroundColor: '$transparentBorder',
  borderRadius: '$3',
  opacity: 0.6,
});

export interface SkeletonBoxProps {
  width?: number | string;
  height?: number | string;
  borderRadius?: string;
}

export const SkeletonBox: React.FC<SkeletonBoxProps> = ({
  width = '100%',
  height = 20,
  borderRadius = '$3',
}) => <SkeletonContainer width={width} height={height} borderRadius={borderRadius} />;
